/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_DescriptionInputs */

const en_cc_description = /** @type {(inputs: Cc_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a selected meeting link to the Location field of your Calendar event draft.`)
};

const id_cc_description = /** @type {(inputs: Cc_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan tautan meeting yang Anda pilih ke kolom Lokasi draf acara Calendar.`)
};

/**
* | output |
* | --- |
* | "Add a selected meeting link to the Location field of your Calendar event draft." |
*
* @param {Cc_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_description = /** @type {((inputs?: Cc_DescriptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_DescriptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_description(inputs)
	return en_cc_description(inputs)
});